import { ApiClient, PagedResults, ServiceResponse, ServiceResponseNoContent } from "../../../common";
import { PlatformSettings } from "../../../settings/platformSettings";
import { CreateEnquiryDto } from "../../dtos/in/createEnquiryDto";
import { CreateEnquiryNoteDto } from "../../dtos/in/createEnquiryNoteDto";
import { EnquirySearchParamsDto } from "../../dtos/in/enquirySearchParamsDto";
import { UpdateEnquiryNoteDto } from "../../dtos/in/updateEnquiryNoteDto";
import { EnquiryDto } from "../../dtos/out/enquiryDto";
import { EnquiryNoteDto } from "../../dtos/out/enquiryNoteDto";
import { EnquiryStatus } from "../../enums/enquiryStatus";
import { IFormsClient } from "../interfaces/formsClient";

class FormsClient extends ApiClient implements IFormsClient {

    private _baseUrl: string;
    constructor(private platformSettings: PlatformSettings) {
        super();
        this._baseUrl = platformSettings.apiUrl + "/forms";
    }
    

    get baseUrl(): string {
        return this._baseUrl;
    }

    public async createEnquiry(dto: CreateEnquiryDto, accessToken: string): Promise<ServiceResponse<EnquiryDto>> {
        return await super.Post<CreateEnquiryDto, EnquiryDto>(this.baseUrl, `enquiries`, dto, accessToken);
    }

    public async searchEnquiries(searchParams: EnquirySearchParamsDto, accessToken: string): Promise<ServiceResponse<PagedResults<EnquiryDto>>> {
        return await super.Get<PagedResults<EnquiryDto>>(this.baseUrl, `enquiries/search-results/${searchParams}`,accessToken);
    }

    public async setEnquiryStatus(enquiryId: string, status: EnquiryStatus, accessToken: string): Promise<ServiceResponseNoContent> {
        return await super.Put(this.baseUrl, null, `enquiries/${enquiryId}/status/${status}`, accessToken);
    }

    public async setEnquiryPartnerEnquiryId(enquiryId: string, partnerEnquiryId: string, accessToken: string): Promise<ServiceResponseNoContent> {
        return await super.Put(this.baseUrl, null, `enquiries/${enquiryId}/partnerEnquiryId/${partnerEnquiryId}`, accessToken);
    }

    public async getEnquiry(enquiryId: string, accessToken: string): Promise<ServiceResponse<EnquiryDto>> {
        return await super.Get<EnquiryDto>(this.baseUrl, `enquiries/${enquiryId}`, accessToken);
    }

    public async deleteEnquiry(enquiryId: string, accessToken: string): Promise<ServiceResponseNoContent> {
        return await super.Delete(this.baseUrl, `enquiries/${enquiryId}`, accessToken);
    }

    public async createEnquiryNote(dto: CreateEnquiryNoteDto, accessToken: string): Promise<ServiceResponse<EnquiryNoteDto>> {
        return await super.Post<CreateEnquiryNoteDto, EnquiryNoteDto>(this.baseUrl, `enquiry-notes`, dto, accessToken);
    }

    public async updateEnquiryNote(noteId: string, dto: UpdateEnquiryNoteDto, accessToken: string): Promise<ServiceResponse<EnquiryNoteDto>> {
        return await super.Put<UpdateEnquiryNoteDto, EnquiryNoteDto>(this.baseUrl, `enquiry-notes/${noteId}`, dto, accessToken);
    }

    public async getEnquiryNote(noteId: string, accessToken: string): Promise<ServiceResponse<EnquiryNoteDto>> {
        return await super.Get<EnquiryNoteDto>(this.baseUrl, `enquiry-notes/${noteId}`, accessToken);
    }

    public async getEnquiryNotes(enquiryId: string, accessToken: string): Promise<ServiceResponse<Array<EnquiryNoteDto>>> {
        return await super.Get<Array<EnquiryNoteDto>>(this.baseUrl, `enquiries/${enquiryId}/enquiry-notes`, accessToken);
    }

    public async deleteEnquiryNote(noteId: string, accessToken: string): Promise<ServiceResponseNoContent> {
        return await super.Delete(this.baseUrl, `enquiry-notes/${noteId}`, accessToken);
    }
}

export { FormsClient }